import { parseAsString, useQueryState } from "nuqs"
import React, { ReactNode, useEffect, useState } from "react"

import { ProfileDetailsSection } from "@/features/users/components/profile/profile-details"
import { ProfileHeader } from "@/features/users/components/profile/profile-header"
import { SocialProfileSection } from "@/features/users/components/profile/social-profile-section"
import { cn } from "@/modules/helpers/hooks/shared/utils"

interface Tab {
  key: string
  label: string
  count?: number
}

interface TabsProps {
  tabs: Tab[]
  defaultActive: string
  children: ReactNode
  onChange?: (key: string) => void
}

export const Tabs: React.FC<TabsProps> = ({ tabs, defaultActive, children, onChange }) => {
  const [active, setActive] = useState(defaultActive)
  const activeIndex = tabs.findIndex((t) => t.key === active)

  const handleChange = (key: string) => {
    setActive(key)
    onChange?.(key)
  }
  useEffect(() => {
    setActive(defaultActive)
  }, [defaultActive])

  return (
    <div className="w-full">
      {/* Tab header */}
      <div className="relative border-b border-gray-200">
        {/* indicator chạy qua lại */}
        <span
          className="absolute bottom-0 h-[2px] bg-primary transition-all duration-300 ease-in-out"
          style={{
            width: "100px",
            transform: `translateX(${activeIndex * 100}px)`
          }}
        />

        <div className="flex">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleChange(tab.key)}
              className={cn(
                "relative px-3 w-[100px] py-2 text-sm font-medium transition-colors inline-flex items-center justify-center gap-1",
                active === tab.key ? "text-black" : "text-gray-500 hover:text-gray-700"
              )}
            >
              <span className="text-sm font-normal text-nowrap">{tab.label}</span>
              {typeof tab.count === "number" && (
                <span className="text-[10px] text-gray-900 bg-gray-100 w-5 h-5 inline-flex justify-center items-center rounded-sm font-medium">
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className="mt-4">
        {React.Children.map(children, (child: any) =>
          child.props.value === active ? child : null
        )}
      </div>
    </div>
  )
}

interface TabsContentProps {
  value: string
  children: ReactNode
  className?: string
}

export const TabsContent: React.FC<TabsContentProps> = ({ children, className }) => {
  return <div className={cn("w-full", className)}>{children}</div>
}
const Profile = () => {
  const [tab, setTab] = useQueryState("tab", parseAsString.withDefault("social"))

  return (
    <div className="h-full w-full bg-white">
      <div className="flex-1 flex flex-col h-full">
        <ProfileHeader editable={true} />
        <div className="p-4">
          <Tabs
            defaultActive={tab}
            tabs={[
              { key: "social", label: "Mạng xã hội" },
              { key: "profile", label: "Hồ sơ" }
              // { key: "pricing", label: "Bảng giá" }
            ]}
            onChange={(key) => setTab(key)}
          >
            <TabsContent value="social">
              <SocialProfileSection isProfile />
            </TabsContent>
            <TabsContent value="profile">
              <ProfileDetailsSection />
            </TabsContent>
            {/* <TabsContent value="pricing">Bảng giá</TabsContent> */}
          </Tabs>
        </div>
        {/* <div className="flex flex-col gap-2  py-3 flex-1 h-full">
          <div className="px-2 flex-1 pb-6">
            {tab === "account" && <AccountTab searchParams={searchParams} />}
            {tab === "profile" && <ProfileInfoTab />}
            {tab === "pricing" && <PricingTab />}
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Profile
